import { useSearchParams } from 'react-router-dom'

export type UseSearchParamResult = [string, (newValue: string | null) => void]
/**
 * This is similar to search param but will be updating only single key
 * @param key - the search param key
 * @param defaultValue - string value that will be used if the search param is not found
 */

export function useSearchParam(key: string, defaultValue?: string): UseSearchParamResult {
  const [searchParams, setSearchParams] = useSearchParams()

  const value = searchParams.get(key) ?? defaultValue

  const setValue = (newValue: string | null) => {
    const newParams = new URLSearchParams(searchParams)
    if (newValue === null) {
      newParams.delete(key)
    } else {
      newParams.set(key, newValue)
    }
    setSearchParams(newParams)
  }

  return [value, setValue] as const
}
